import "dayjs/locale/en-gb";
import "dayjs/locale/es";
import "dayjs/locale/ja";
import "dayjs/locale/pt-br";
import "dayjs/locale/pl";
import "dayjs/locale/zh-cn";
import "dayjs/locale/it";
import "dayjs/locale/el";

import datetime from "config/datetime";

const DEFAULT_LOCALE = "en";

datetime.locale(DEFAULT_LOCALE);
